import { connect } from 'react-redux';
import ProtectedRoute from 'routes/ProtectedRoute';
import { getIsLoggedIn } from 'auth/store/selectors';

const mapState = (state: any) => ({
  user: state.auth.user,
  isLogged: getIsLoggedIn(state),
});

export default connect(mapState)(ProtectedRoute);
